export const TeamFilters = () => {
    jQuery(function () {
        if($("body").hasClass("master-team") && !$("body").hasClass("vue-master-team")) {
            let selectedFilters = JSON.parse(localStorage.getItem('selectedFilters') || '[]');
            selectedFilters.forEach(function(filterId) {
                $("#" + filterId).prop('checked', true);
            });

            handler();

            $('.search-field__x').on('click', function (e) {
                e.preventDefault();
                $('.team-member-search #search-field-2').val('');
                $(this).hide();
                handler();
            });

            $("form.team-member-search").on('keyup', function (e) {
                e.preventDefault();
                handler();
            });

            $("form.team-member-search").on('keydown', function (e) {
                if(e.keyCode == 13) {
                    e.preventDefault();
                }
            });

            $(".master-team input[type=checkbox]").click(function(e) {
                if($(this).hasClass('check-all')) {
                    $(this).closest('ul').find("input[type=checkbox]").prop('checked', false);
                    $(this).prop('checked', true);
                } else if($(this).closest('ul').find("input[type=checkbox]:checked").length == 0) {
                    $(this).closest('ul').find("input[type=checkbox].check-all").prop('checked', true);
                } else {
                    $(this).closest('ul').find("input[type=checkbox].check-all").prop('checked', false);
                }

                let selectedFilters = [];
                $(".master-team input[type=checkbox]:checked").each(function() {
                    selectedFilters.push($(this).attr('id'));
                });
                localStorage.setItem('selectedFilters', JSON.stringify(selectedFilters));

                handler();
            });
        }
    });

    const handler = () => {
        let search = $("form.team-member-search [type=search]").val();
        let verticals = [];
        let roles = [];

        if (search.length > 0) {
            $('.search-field__x').show()
        } else {
            $('.search-field__x').hide()
        }

        $('[name="vertical"]:checked').each(function () {
            const verticalValue = $(this).val();
            if (verticalValue) {
                verticals.push(verticalValue);
            }
        });

        $('[name="role"]:checked').each(function () {
            const roleValue = $(this).val();
            if (roleValue) {
                roles.push(roleValue);
            }
        });


        const memberIds = getMemberIds(search, verticals, roles);

        const members = $(".all-team-list .member");
        const noResultsMessage = $('.all-team-list .no-results');
        $(".all-team-list .all-team-cta").remove();
        members.hide();
        noResultsMessage.hide();

        if(memberIds.length) {
            let bannerIndex = 0;
            let filteredMembers = members.filter(function(){
                return memberIds.includes($(this).data('id'));
            });

            filteredMembers.show();

            while(typeof ctas[bannerIndex] !== 'undefined' && filteredMembers.length > (4 * ctaSpacing * (bannerIndex + 1))) {
                const banner =  generateCtaBanner(
                    ctas[bannerIndex].title,
                    ctas[bannerIndex].subtitle,
                    ctas[bannerIndex].cta,
                    ctas[bannerIndex].background_color,
                    ctas[bannerIndex].image
                );
                $(banner).insertBefore(filteredMembers[(4 * ctaSpacing * (bannerIndex + 1))]);
                bannerIndex++;
            }
        } else {
            noResultsMessage.show();
        }
    };

    const getMemberIds = (search, verticals, roles) => {
        let members_ids = [];
        search = search.toLowerCase();
        verticals = verticals.map(v => v.toLowerCase());
        roles = roles.map(r => r.toLowerCase());

        $(".all-team-list .member").each(function() {
            const member = $(this);
            const memberName = member.data("name").toLowerCase();
            const memberVerticals = member.data("verticals")?.split(",").map(v => v.trim().toLowerCase());
            const memberRoleIds = member.data("team-role-ids")?.toString().split(",").map(r => r.toLowerCase());

            if (
                memberName.includes(search) &&
                (verticals.length === 0 || memberVerticals?.some(v => verticals.includes(v))) &&
                (roles.length === 0 || memberRoleIds?.some(r => roles.includes(r)))
            ) {
                members_ids.push(member.data("id"));
            }
        });

        return members_ids;
    }

    const generateCtaBanner = (title, subtitle, link, bgColor, imageUrl) => {
        return `
        <div class="all-team-cta" style="background: ${bgColor}${imageUrl ? ` url('${imageUrl}') no-repeat 100% 100% / cover` : ''}">
            <div class="holder">
                ${title ? `<h3>${title}</h3>` : ''}
                ${subtitle ? `<h4>${subtitle}</h4>` : ''}
                ${link.title ? `<a href="${link.url}" target="${link.target}" class="btn">${link.title}</a>` : ''}
            </div>
        </div>`;
    }
}
